import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/icon-arrow-right-green.png'
import _imports_1 from '@/assets/icon/icon-wrong.png'


const _withScopeId = n => (_pushScopeId("data-v-75116ce6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-pdo-program-list" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = {
  key: 1,
  class: "box-list"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "name" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "state-text"
}
const _hoisted_8 = ["onClick"]

import { onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { Collection } from '@/stores';
  import { request, confirm } from '@/utils';
  import { useRouter, useRoute } from 'vue-router';
  import { USER_REQUEST_STATE_MAP, ColorVariants } from '@/constants';
  import { useToast } from 'bootstrap-vue-3';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const toast = useToast();
  const store = Collection.create<Collection>({
    fetch(params = {}) {
      return request.get('/pdos/mine/pdos', { params: { ...params, page: route.query.page } });
    }
  });

  onMounted(() => {
    store.fetchData();
  });

  const router = useRouter();
  const route = useRoute();
  const handlePageChange = (page: any) => {
    router.replace({ query: { ...route.query, page } });
  };

  async function handleDeletePdo(id: number) {
    await confirm(t('delete_confirm_text'));
    await request.delete(`pdos/mine/pdos/${id}`);
    store.fetchData();
    toast.show({ title: t('Success'), body: t('Operation success') }, { variant: ColorVariants.success });
  }

return (_ctx: any,_cache: any) => {
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppPagination = _resolveComponent("AppPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('PDO Dashboard')), 1),
    (_unref(store).isEmpty)
      ? (_openBlock(), _createBlock(_component_AppEmptyView, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).data, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "item-card"
            }, [
              _createElementVNode("img", {
                src: item.program.image?.url,
                class: "image"
              }, null, 8, _hoisted_4),
              _createElementVNode("span", _hoisted_5, _toDisplayString(item.program.name), 1),
              (item.state === 'approved' && item.collection_method !== 'no_registration')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { name: 'pdo.program', params: { id: item.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('Detail')) + " ", 1),
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true),
              (item.state !== 'approved')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(USER_REQUEST_STATE_MAP)[item.state]), 1))
                : _createCommentVNode("", true),
              _createElementVNode("img", {
                class: "icon-delete",
                src: _imports_1,
                onClick: ($event: any) => (handleDeletePdo(item.id))
              }, null, 8, _hoisted_8)
            ]))
          }), 128))
        ])),
    (_unref(store).meta.total_pages > 1)
      ? (_openBlock(), _createBlock(_component_AppPagination, {
          key: 2,
          total: _unref(store).meta.total,
          "per-page": _unref(store).meta.per_page,
          page: _unref(store).meta.page,
          onChange: handlePageChange
        }, null, 8, ["total", "per-page", "page"]))
      : _createCommentVNode("", true)
  ]))
}
}

})